import { useEffect, useRef } from 'react'
import { useTreeState } from '../../../stores/Root'
import { undoManager } from '../../../stores/StudioStore'
import { clampToValue } from '../../core/Utils'
import { getClipClampFraction } from '../../studio/hooks/useClip'

const useClipHandle = (
  onMove: (deltaPX: number) => boolean,
  instrumentLoopWidthPX?: number,
  dependencies: any[] = [], // anything you want to trigger an update of the custom onDrag event
  snapToGrid: boolean = false
) => {
  const handleRef = useRef(null)
  const { studio } = useTreeState()
  const clampFraction = getClipClampFraction(instrumentLoopWidthPX)

  useEffect(() => {
    const handle = handleRef.current
    if (!handle) return
    let pressed = false
    let pressedX = -1
    handle.onmousedown = (evt) => {
      evt.preventDefault()
      evt.stopPropagation()
      if (evt.which !== 1) return

      studio.disableAudioUpdates()

      undoManager.startGroup(() => {
        pressedX = evt.pageX
        pressed = true
        const onMouseMove = (evt) => {
          evt.preventDefault()
          evt.stopPropagation()
          const updateSuccessful = onMove(evt.pageX - pressedX)
          if (updateSuccessful) {
            pressedX = snapToGrid
              ? clampToValue(evt.pageX, instrumentLoopWidthPX / clampFraction)
              : evt.pageX
          }
        }
        const onMouseUp = () => {
          pressed = false
          document.removeEventListener('mousemove', onMouseMove)
          undoManager.stopGroup()
          studio.enableAudioUpdates()
        }
        document.addEventListener('mousemove', onMouseMove)
        document.addEventListener('mouseup', onMouseUp, { once: true })
      })
    }

    return () => {}
  }, [instrumentLoopWidthPX, handleRef.current, snapToGrid, ...dependencies])

  return { handleRef }
}

export default useClipHandle
